import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";

import iconCheckTrue from "../../static/images/Aktiv.svg";
import iconCheckFalse from "../../static/images/Inaktiv.svg";
import iconCheckUndefined from "../../static/images/Neutral.svg";

class Switcher extends React.PureComponent {
  switcherSize = 0.8 * 72;

  handleCheckMarketGoal = state => {
    this.props.onHandleCheckMarketGoal(this.props.item._id, state);
  };

  $onMouseDown = event => {
    event.preventDefault();

    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }
    this.$onDragStart(event.clientX);
    window.addEventListener("mousemove", this.$onMouseMove);
    window.addEventListener("mouseup", this.$onMouseUp);
  };

  $onMouseMove = event => {
    event.preventDefault();
    this.$onDrag(event.clientX);
  };

  $onMouseUp = () => {
    window.removeEventListener("mousemove", this.$onMouseMove);
    window.removeEventListener("mouseup", this.$onMouseUp);
  };

  $onDragStart = clientX => {
    this.setState({
      $startX: clientX,
      $dragStartingTime: Date.now(),
    });
  };

  $onDrag = clientX => {
    const { $startX } = this.state;

    if (this.props?.value === 0) {
      if ($startX - clientX > this.switcherSize / 3) {
        return this.updateStateAndValue(clientX, -1);
      }
      if (clientX - $startX > this.switcherSize / 3) {
        return this.updateStateAndValue(clientX, 1);
      }
    }

    if (this.props?.value === 1) {
      if ($startX - clientX > (2 * this.switcherSize) / 3) {
        return this.updateStateAndValue(clientX, -1);
      }
      if ($startX - clientX > this.switcherSize / 3) {
        return this.updateStateAndValue(clientX, 0);
      }
    }

    if (this.props?.value === -1) {
      if (clientX - $startX > (2 * this.switcherSize) / 3) {
        return this.updateStateAndValue(clientX, 1);
      }
      if (clientX - $startX > this.switcherSize / 3) {
        return this.updateStateAndValue(clientX, 0);
      }
    }
  };

  updateStateAndValue = (startX, value) => {
    this.handleCheckMarketGoal(value);
    return this.setState({
      $startX: startX,
    });
  };

  $onTouchStart = event => {
    this.$onDragStart(event.touches[0].clientX);
  };

  $onTouchMove = event => {
    return this.$onDrag(event.touches[0].clientX);
  };

  getSwitcherIcon = value => {
    switch (value) {
      case -1:
        return iconCheckFalse;
      case 1:
        return iconCheckTrue;
      default:
        return iconCheckUndefined;
    }
  };

  render() {
    return (
      <div
        className={`form-marketGoal-check-input${
          this.props?.value === 1
            ? " form-marketGoal-true"
            : this.props?.value === -1
              ? " form-marketGoal-false"
              : " form-marketGoal-undefined"
        }`}
      >
        <div className={"form-marketGoal-check-btn"} onClick={() => this.handleCheckMarketGoal(-1)} />
        <div className={"form-marketGoal-check-btn"} onClick={() => this.handleCheckMarketGoal(0)} />
        <div className={"form-marketGoal-check-btn"} onClick={() => this.handleCheckMarketGoal(1)} />
        <img
          alt=""
          className={this.props?.value === 1 ? "true" : this.props?.value === -1 ? "false" : "undefined"}
          src={this.getSwitcherIcon(this.props?.value)}
          onMouseDown={this.$onMouseDown}
          onTouchStart={this.$onTouchStart}
          onTouchMove={this.$onTouchMove}
        />
      </div>
    );
  }
}

Switcher.propTypes = {
  value: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  onHandleCheckMarketGoal: PropTypes.func.isRequired,
};

Switcher.defaultProps = {
  value: 0,
  item: { _id: "123" },
  onHandleCheckMarketGoal: () => {},
};

export default Switcher;
